export default __webpack_public_path__ + "static/media/refresh.dfb6f523.svg";